// App.tsx
import type React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import ReportPage, { PreviewPage } from './components/ReportPage';
import PlayerReportPage from './components/PlayerReportPage';
import TournamentPage from './components/tournament/TournamentPage';

const InvalidRoute: React.FC = () => {
  const { t } = useTranslation('common');
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3">
      <AlertCircle className="h-8 w-8 text-slate-400" />
      <p className="text-slate-500">{t('somethingWentWrong')}</p>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Routes>
          {/* Cross-session player report. Listed before the generic two-segment
              route so React Router's specificity ranking picks it for /player/* */}
          <Route path="/player/:userId" element={<PlayerReportPage />} />
          <Route path="/tournament" element={<TournamentPage />} />
          <Route path="/preview" element={<PreviewPage />} />
          <Route path="/:sessionId/:playerId" element={<ReportPage />} />
          {import.meta.env.VITE_LOCAL_JSON && (
            <Route path="*" element={<ReportPage />} />
          )}
          {!import.meta.env.VITE_LOCAL_JSON && (
            <Route path="*" element={<InvalidRoute />} />
          )}
        </Routes>
      </div>
    </Router>
  );
};

export default App;
